import { AppShell } from "@/components/AppShell";
import { NewsSection } from "./admin-area/NewsSection";
import { ProjectImportSection } from "./admin-area/ProjectImportSection";
import { StripHeroSection } from "./admin-area/StripHeroSection";
import { KevoxBakSection } from "./admin-area/KevoxBakSection";
import { KevoxZipSection } from "./admin-area/KevoxZipSection";
import { ScheduledCallsSection } from "./admin-area/ScheduledCallsSection";
import { ApiTokensSection } from "./admin-area/ApiTokensSection";
import { DisplayDevicesSection } from "./admin-area/DisplayDevicesSection";
import { AppHealthSection } from "./admin-area/AppHealthSection";

export function AdminAreaPage() {
  return (
    <AppShell
      title="Admin-Bereich"
      subtitle="Neuigkeiten, Importe und Werkzeuge."
      back={{ to: "/admin", label: "zurück zum Admin-Hub" }}
    >
      <AppHealthSection />
      <NewsSection />
      <ProjectImportSection />
      <StripHeroSection />
      <KevoxBakSection />
      <KevoxZipSection />
      <ScheduledCallsSection />
      <DisplayDevicesSection />
      <ApiTokensSection />
    </AppShell>
  );
}
